<script>
    import { onMount } from "svelte";
    import { generateRandomId } from "../utils/IdentifierGenerator";
    import performanceFactory from "../performance/performance";
    import collapsedTracker from "../tracking/collapsedTracker";
    import SheetButton from "../components/SheetButton.svelte";
    import ajaxFetch from "../services/ajaxFetch";

    let { variationId, parentTrackingId, errorCallback } = $props();

    let headline = $state(),
        recommendations = $state(),
        metaData = $state(),
        tracking = $state(),
        additionalClickTracking = $state();
    let expandableCinemaHasLoaded = $state(false);

    let featuresState = $state();
    const cinemaId = `reco_expandable_cinema__${generateRandomId(16)}`;
    const DEFAULT_TRACKING_FIELD = "99";
    const buttonPerformance = performanceFactory(window, "button");

    onMount(async () => {
        buttonPerformance.cinemaLoadingStarted();
        const res = await ajaxFetch(`/reco-core/recommendations/wishlist/variations/${variationId}`);
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            headline,
            recommendations,
            metaData,
            tracking,
            additionalClickTracking,
            featuresState = {},
        } = await res.json());

        expandableCinemaHasLoaded = true;
        collapsedTracker(tracking, DEFAULT_TRACKING_FIELD, parentTrackingId);
        buttonPerformance.cinemaLoaded("reco_wishlist_button");
    });
</script>

{#if expandableCinemaHasLoaded}
    <div class="reco_expandable_cinema_wrapper">
        <div class="pl_table-view reco_expandable_cinema {cinemaId}">
            <div class="pl_table-view--item pl_table-view--item-fully-clickable pl_table-view--item-no-divider">
                <SheetButton
                    sourceVariationId={variationId}
                    recommendationsCount={recommendations.length}
                    {headline}
                    {recommendations}
                    cinemaMeta={metaData}
                    {tracking}
                    {additionalClickTracking}
                    {featuresState}
                />
            </div>
        </div>
    </div>
{/if}

<style lang="scss">
    .reco_expandable_cinema {
        padding: 0;

        &_hidden {
            display: none;
        }
    }
</style>
